import { useTable } from 'spacetimedb/react';
import { tables as minetwinTables } from '@sdk/minetwin';

/**
 * Subscribed `cohort_step_metrics` rows. One row per (assignment, step,
 * attempt) — written by the agent as it advances through an orientation.
 *
 * Used by Review Queue to compute "rushed" attention flags
 * (`timeSpentSeconds < durationMinutes * 60 * 0.5`, per Ludvig's hookup plan).
 */
export function useCohortStepMetrics() {
  const [rows, isReady] = useTable(
    'minetwin',
    minetwinTables.cohort_step_metrics,
  );
  return { rows, isReady };
}
